import React from 'react';

import PropertyCardContent from 'bundles/crm/properties/card/content';
import Thumbnail from 'bundles/crm/properties/thumbnail';
import { Button } from 'components/ui/button';
import { convertToEdgeCrmProperty } from 'bundles/research/index/helpers';

import type { Property } from 'bundles/research/index/properties/types';

interface Props {
  googleMapsApiKey: string;
  goToPropertyShow: (event: React.MouseEvent, property: Property) => void;
  property: Property;
}

export default function MapInfoBubbleContentV2({ googleMapsApiKey, goToPropertyShow, property }: Props) {
  if (!property) {
    // Some things on the map aren't results - those are loaded async, but this is "displayed" first
    return null;
  }

  return (
    <div>
      <Thumbnail
        googleMapsApiKey={googleMapsApiKey}
        height={135}
        property={property}
        width={400}
      />

      <div className="p-4 d-flex justify-content-between">
        <PropertyCardContent property={convertToEdgeCrmProperty(property)} />
        <div>
          <Button label="View" onClick={event => goToPropertyShow(event, property)} />
        </div>
      </div>
    </div>
  );
}
